// extracted by mini-css-extract-plugin
export default {"admin_nav":"AdminNav_admin_nav__Q8WdL","active":"AdminNav_active__8cBrJ","more":"AdminNav_more__pmmcP"};